module.exports = __webpack_public_path__ + "static/media/logoradio.cfc8273e.jpg";